<div class="min-h-screen  text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
    <!-- Header -->
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
        <div>
            <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">กลุ่มเมนูหลัก</h1>
            <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">จัดการข้อมูลและโครงสร้างกลุ่มเมนูหลักในระบบ
            </p>
        </div>
        <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
            <button (click)="toggleDashboard()"
                class="w-full sm:w-auto px-4 py-3 bg-white/95 dark:bg-slate-900/95 text-slate-600 dark:text-slate-300 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all font-bold flex items-center justify-center gap-2 active:scale-95">
                <span class="material-icons text-[18px]">{{ isDashboardOpen() ? 'bar_chart' : 'show_chart' }}</span>
                แดชบอร์ด
            </button>
            <button (click)="exportMenuData()" [disabled]="isExporting()"
                class="w-full sm:w-auto px-4 py-3 bg-emerald-500 dark:bg-emerald-500 text-white dark:text-white hover:text-white/90 dark:hover:text-white/90 hover:scale-98 cursor-pointer rounded-2xl shadow-sm border border-slate-100/50  transition-all font-bold flex items-center justify-center gap-2 active:scale-95 disabled:opacity-50">
                <span class="material-icons text-[18px]">download</span>
                ส่งออกเมนู (Export)
            </button>
            <button (click)="fileInput.click()"
                class="w-full sm:w-auto px-4 py-3 bg-blue-500 dark:bg-blue-500 text-white dark:text-white hover:text-white/90 dark:hover:text-white/90 hover:scale-98 cursor-pointer rounded-2xl shadow-sm border border-slate-100/50  transition-all font-bold flex items-center justify-center gap-2 active:scale-95">
                <span class="material-icons text-[18px]">upload</span>
                นำเข้าเมนู (Import)
            </button>
            <input type="file" #fileInput (change)="onFileSelected($event)" accept=".json" class="hidden">
            <button (click)="onRefresh()"
                class="w-full sm:w-auto p-3 bg-white/95 dark:bg-slate-900/95 text-slate-500 dark:text-slate-400 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 backdrop-blur-sm flex items-center justify-center">
                <span class="material-icons">refresh</span>
            </button>
            <button (click)="navigateToCreate()"
                class="w-full sm:w-auto px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-2xl hover:shadow-[0_8px_25px_rgb(251,191,36,0.4)] hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2">
                <span class="material-icons text-xl">add_circle</span>
                สร้างกลุ่มเมนู
            </button>
        </div>
    </div>

    <!-- Stats Box Grid -->
    <div *ngIf="isDashboardOpen()" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        <div *ngFor="let stat of dashboardStats(); let i = index"
            class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-2xl p-6 shadow-2xl border border-slate-100/50 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] dark:hover:shadow-[0_8px_30px_rgb(0,0,0,0.3)] hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group"
            [ngStyle]="{'animation-delay': (i * 0.05) + 's'}">

            <div class="absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-[0.08] dark:opacity-10 transition-transform group-hover:scale-110"
                [ngClass]="stat.color.split(' ')[0].replace('text-', 'bg-')"></div>

            <div class="relative z-10 flex justify-between items-start mb-4">
                <div class="w-auto min-w-12 h-12 p-2 rounded-xl flex items-center justify-center shadow-sm"
                    [ngClass]="stat.color.replace('text-', 'bg-').replace('500', '50') + ' ' + stat.color + ' dark:bg-opacity-20'">
                    <span class="material-icons text-2xl group-hover:scale-110 transition-transform">{{ stat.icon
                        }}</span>
                </div>
            </div>

            <div class="relative z-10">
                <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1 truncate">{{ stat.title }}
                </h4>
                <div class="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">{{ stat.value }}
                </div>
            </div>
        </div>
    </div>

    <!-- Table Container -->
    <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden"
        style="animation-delay: 0.1s;">

        <!-- Table Control Bar -->
        <div class="p-6 border-b border-slate-100/50 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <span class="material-icons text-amber-500">grid_view</span>
                รายการกลุ่มเมนูย่อย
            </h3>

            <div class="flex items-center gap-3 w-full sm:w-auto max-w-sm">
                <div class="relative flex-1 flex w-full">
                    <div
                        class="relative w-full flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:bg-white dark:focus-within:bg-slate-800/80 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all overflow-hidden h-[42px]">
                        <span class="absolute left-3 material-icons text-slate-400 text-[20px]">search</span>
                        <input type="text" placeholder="ค้นหากลุ่มเมนูหลัก..." [ngModel]="searchText()"
                            (ngModelChange)="searchText.set($event); onSearch()"
                            class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-600 dark:text-slate-300 focus:ring-0 focus:outline-none placeholder:text-slate-400">
                    </div>
                </div>
            </div>
        </div>

        <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
            <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading()"
                [class.pointer-events-none]="isLoading()">
                <thead
                    class="sticky top-0 z-20 bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm shadow-sm border-b border-slate-100/50">
                    <tr class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest">
                        <th (click)="sortData('number')"
                            class="p-4 whitespace-nowrap cursor-pointer hover:text-slate-600 transition-colors group w-[100px]">
                            <div class="flex items-center gap-1">ลำดับ<span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn() === 'number'">{{ sortColumn() === 'number' &&
                                    sortDirection() === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</span></div>
                        </th>
                        <th (click)="sortData('id')"
                            class="p-4 whitespace-nowrap cursor-pointer hover:text-slate-600 transition-colors group w-[100px]">
                            <div class="flex items-center gap-1">ID<span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn() === 'id'">{{ sortColumn() === 'id' &&
                                    sortDirection() === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</span></div>
                        </th>
                        <th (click)="sortData('name')"
                            class="p-4 whitespace-nowrap cursor-pointer hover:text-slate-600 transition-colors group w-[45%]">
                            <div class="flex items-center gap-1">ชื่อกลุ่มเมนูหลัก<span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn() === 'name'">{{ sortColumn() === 'name' &&
                                    sortDirection() === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</span></div>
                        </th>
                        <th (click)="sortData('status')"
                            class="p-4 whitespace-nowrap cursor-pointer hover:text-slate-600 transition-colors group">
                            <div class="flex items-center gap-1">สถานะ<span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn() === 'status'">{{ sortColumn() === 'status' &&
                                    sortDirection() === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</span></div>
                        </th>
                        <th (click)="sortData('createDate')"
                            class="p-4 whitespace-nowrap cursor-pointer hover:text-slate-600 transition-colors group">
                            <div class="flex items-center gap-1">วันที่สร้าง<span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn() === 'createDate'">{{ sortColumn() === 'createDate'
                                    && sortDirection() === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</span></div>
                        </th>
                        <th class="p-4 w-[150px] text-center">จัดการ</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
                    <tr *ngFor="let m of filteredAndPaginatedData(); let i = index; trackBy: trackById"
                        class="animate-fade-in-up group hover:bg-slate-50/50 dark:hover:bg-slate-800/50 transition-all"
                        [ngStyle]="{'animation-delay': (i * 0.03) + 's'}">

                        <td class="p-4 font-mono font-bold">{{ m.number }}</td>
                        <td class="p-4 font-mono text-slate-400">{{ m.id }}</td>
                        <td class="p-4">
                            <span class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ m.name }}</span>
                        </td>
                        <td class="p-4">
                            <!-- Read-only status badge — edit via modal -->
                            <span
                                class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold"
                                [ngClass]="m.status
                                    ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                                    : 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400'">
                                <span class="w-1.5 h-1.5 rounded-full"
                                    [ngClass]="m.status ? 'bg-emerald-500' : 'bg-slate-400'"></span>
                                {{ m.status ? 'ใช้งาน' : 'ปิดใช้งาน' }}
                            </span>
                        </td>
                        <td class="p-4 text-slate-400 dark:text-slate-500 text-xs">
                            {{ m.createDate | date:'dd/MM/yyyy HH:mm' }}
                        </td>
                        <td class="p-4 text-center">
                            <div class="flex items-center justify-center gap-2">
                                <button (click)="navigateToEdit(m)"
                                    class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-amber-400 dark:border-slate-700 dark:hover:border-amber-400 text-slate-400 hover:text-amber-500 transition-all hover:shadow-sm">
                                    <span class="material-icons text-base">edit</span>
                                </button>
                            </div>
                        </td>
                    </tr>

                    <tr *ngIf="filteredAndPaginatedData().length === 0 && !isLoading()">
                        <td [attr.colspan]="6" class="py-20 text-center">
                            <div class="flex flex-col items-center justify-center">
                                <div
                                    class="w-16 h-16 bg-slate-50 dark:bg-slate-800 rounded-full flex items-center justify-center mb-3">
                                    <span
                                        class="material-icons text-3xl text-slate-300 dark:text-slate-600">search_off</span>
                                </div>
                                <h3 class="text-slate-800 dark:text-slate-200 font-bold">ไม่พบข้อมูล</h3>
                                <span
                                    class="text-slate-400 dark:text-slate-500 text-sm mt-1">ลองปรับการค้นหาใหม่อีกครั้ง</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div
            class="px-6 py-4 border-t border-slate-100/50 bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm flex flex-col md:flex-row items-center justify-between gap-4 w-full">
            <div class="flex items-center gap-4 text-sm text-slate-500 dark:text-slate-400 font-medium">
                <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }}
                    รายการ</span>
                <select (change)="onPageSizeChange($event)" [ngModel]="pageSize()"
                    class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 text-sm rounded-lg focus:ring-2 focus:ring-amber-500/30 font-bold cursor-pointer transition-colors outline-none px-2 py-1">
                    <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
                </select>
            </div>

            <div class="flex items-center gap-2">
                <button (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
                    class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 hover:text-amber-500 disabled:opacity-30 transition-all">
                    <span class="material-icons text-sm">chevron_left</span>
                </button>

                <button *ngFor="let page of pagesArray" (click)="setPage(page)"
                    class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
                    [ngClass]="page === currentPage() ? 'bg-amber-400 text-white shadow-lg shadow-amber-200/50 border-amber-400' : 'border-transparent text-slate-600 dark:text-slate-400 hover:bg-amber-50 dark:hover:bg-slate-800 hover:text-amber-500'">
                    {{ page }}
                </button>

                <button (click)="setPage(currentPage() + 1)"
                    [disabled]="currentPage() === totalPages || totalPages === 0"
                    class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 hover:text-amber-500 disabled:opacity-30 transition-all">
                    <span class="material-icons text-sm">chevron_right</span>
                </button>
            </div>
        </div>
    </div>

    <!-- Modals -->
    <app-modal-group-menu *ngIf="isModalOpen()" [data]="selectedItem()" (close)="closeModal()"
        (saveSuccess)="onRefresh()"></app-modal-group-menu>

    <!-- Import Menu Modal -->
    <div *ngIf="isImportModalOpen()"
        class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
        <div
            class="bg-white/95 dark:bg-slate-900/95 backdrop-blur-md rounded-2xl shadow-2xl border border-slate-100/50 dark:border-slate-800 max-w-xl w-full p-6 animate-fade-in-up overflow-hidden">
            <!-- Modal Header -->
            <div class="flex items-center justify-between border-b border-slate-100 dark:border-slate-800 pb-4 mb-4">
                <div class="flex items-center gap-3">
                    <div
                        class="w-10 h-10 rounded-xl bg-amber-50 dark:bg-amber-900/20 text-amber-500 flex items-center justify-center">
                        <span class="material-icons">cloud_upload</span>
                    </div>
                    <div>
                        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">นำเข้าโครงสร้างเมนู</h3>
                        <p class="text-xs text-slate-500 dark:text-slate-400">ไฟล์: {{ selectedFileName() }}</p>
                    </div>
                </div>
                <button (click)="closeImportModal()"
                    class="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200">
                    <span class="material-icons">close</span>
                </button>
            </div>

            <!-- Summary Stats -->
            <div class="grid grid-cols-3 gap-3 mb-6">
                <div
                    class="bg-slate-50 dark:bg-slate-800/60 p-3 rounded-xl text-center border border-slate-100 dark:border-slate-800">
                    <div class="text-xl font-bold text-amber-500">{{ importSummary().groupMenusCount }}</div>
                    <div class="text-xs text-slate-400">กลุ่มเมนูหลัก</div>
                </div>
                <div
                    class="bg-slate-50 dark:bg-slate-800/60 p-3 rounded-xl text-center border border-slate-100 dark:border-slate-800">
                    <div class="text-xl font-bold text-indigo-500">{{ importSummary().groupSubMenusCount }}</div>
                    <div class="text-xs text-slate-400">กลุ่มเมนูย่อย</div>
                </div>
                <div
                    class="bg-slate-50 dark:bg-slate-800/60 p-3 rounded-xl text-center border border-slate-100 dark:border-slate-800">
                    <div class="text-xl font-bold text-emerald-500">{{ importSummary().menuListsCount }}</div>
                    <div class="text-xs text-slate-400">รายการเมนู</div>
                </div>
            </div>

            <!-- Import Strategy Options -->
            <div class="mb-6 space-y-3">
                <label class="block text-xs font-bold uppercase text-slate-400">รูปแบบการจัดการข้อมูลซ้ำ</label>
                <div class="grid grid-cols-1 sm:grid-cols-3 gap-2 text-xs">
                    <label (click)="importMode.set('skip')"
                        class="flex items-center gap-2 p-3 rounded-xl border cursor-pointer transition-all"
                        [ngClass]="importMode() === 'skip' ? 'border-amber-400 bg-amber-50/50 dark:bg-amber-950/20 text-slate-800 dark:text-slate-100 font-bold' : 'border-slate-200 dark:border-slate-800 text-slate-500'">
                        <input type="radio" name="importMode" value="skip" [checked]="importMode() === 'skip'"
                            class="text-amber-500 focus:ring-amber-400">
                        <span>ข้ามรายการเดิม</span>
                    </label>
                    <label (click)="importMode.set('update')"
                        class="flex items-center gap-2 p-3 rounded-xl border cursor-pointer transition-all"
                        [ngClass]="importMode() === 'update' ? 'border-amber-400 bg-amber-50/50 dark:bg-amber-950/20 text-slate-800 dark:text-slate-100 font-bold' : 'border-slate-200 dark:border-slate-800 text-slate-500'">
                        <input type="radio" name="importMode" value="update" [checked]="importMode() === 'update'"
                            class="text-amber-500 focus:ring-amber-400">
                        <span>อัปเดตรายการเดิม</span>
                    </label>
                    <label (click)="importMode.set('force')"
                        class="flex items-center gap-2 p-3 rounded-xl border cursor-pointer transition-all"
                        [ngClass]="importMode() === 'force' ? 'border-amber-400 bg-amber-50/50 dark:bg-amber-950/20 text-slate-800 dark:text-slate-100 font-bold' : 'border-slate-200 dark:border-slate-800 text-slate-500'">
                        <input type="radio" name="importMode" value="force" [checked]="importMode() === 'force'"
                            class="text-amber-500 focus:ring-amber-400">
                        <span>สร้างใหม่ทั้งหมด</span>
                    </label>
                </div>
            </div>

            <!-- Progress Indicator -->
            <div *ngIf="importProgress().total > 0" class="mb-6 space-y-2">
                <div class="flex justify-between text-xs text-slate-500 dark:text-slate-400">
                    <span class="truncate">{{ importProgress().text }}</span>
                    <span class="font-mono font-bold">{{ importProgress().current }}/{{ importProgress().total }}</span>
                </div>
                <div class="w-full bg-slate-100 dark:bg-slate-800 h-2 rounded-full overflow-hidden">
                    <div class="bg-amber-400 h-full transition-all duration-300"
                        [style.width.%]="(importProgress().current / importProgress().total) * 100"></div>
                </div>
            </div>

            <!-- Modal Footer -->
            <div class="flex items-center justify-end gap-3 pt-4 border-t border-slate-100 dark:border-slate-800">
                <button (click)="closeImportModal()" [disabled]="isLoading()"
                    class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 text-sm font-bold transition-all disabled:opacity-50">
                    ยกเลิก
                </button>
                <button (click)="importMenuData()" [disabled]="isLoading()"
                    class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white text-sm font-bold shadow-lg shadow-amber-200/50 transition-all flex items-center gap-2 disabled:opacity-50">
                    <span class="material-icons text-base">cloud_download</span>
                    ยืนยันนำเข้าข้อมูล
                </button>
            </div>
        </div>
    </div>
</div>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>